import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Loader2, Rocket, TrendingUp, IndianRupee, ShieldAlert, ShieldCheck } from "lucide-react";

export default function Careers() {
  const [careers, setCareers] = useState(null);
  const [skills, setSkills] = useState(null);
  useEffect(() => {
    api.get("/careers").then((r) => setCareers(r.data));
    api.get("/human-skills").then((r) => setSkills(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="max-w-3xl mb-12">
        <div className="overline mb-3">Future Career Navigator</div>
        <h1 className="text-4xl sm:text-5xl font-semibold text-brand-blue leading-tight">Careers that will matter in 2045.</h1>
        <p className="mt-4 text-lg text-brand-muted">Prepare your child for what's coming — and for what stays timeless.</p>
      </div>

      {!careers ? <Loader2 className="animate-spin text-brand-green" /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {careers.map((c) => (
            <div key={c.id} data-testid={`career-card-${c.id}`} className="surface surface-hover p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-11 h-11 rounded-xl bg-brand-blue text-white flex items-center justify-center"><Rocket size={20} /></div>
                <h3 className="text-lg font-semibold text-brand-blue">{c.name}</h3>
              </div>
              <p className="text-sm text-brand-muted line-clamp-2">{c.description}</p>
              <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
                <div className="flex items-center gap-1.5 text-brand-green"><TrendingUp size={12} /> {c.demand}</div>
                <div className="flex items-center gap-1.5 text-brand-orange"><IndianRupee size={12} /> {c.income}</div>
                <div className="flex items-center gap-1.5 text-brand-blue col-span-2">
                  {c.human_ai_risk?.toLowerCase().startsWith("low") ? <ShieldCheck size={12} /> : <ShieldAlert size={12} />}
                  <span>AI risk: {c.human_ai_risk}</span>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {(c.skills || []).slice(0, 3).map((s) => <span key={s} className="chip-blue">{s}</span>)}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-20">
        <div className="overline mb-3">Skills that outlast machines</div>
        <h2 className="text-3xl sm:text-4xl font-semibold text-brand-blue">Human skills that will always matter.</h2>
        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {(skills || []).map((s) => (
            <div key={s.name} className="surface p-6">
              <h3 className="text-lg font-semibold text-brand-blue">{s.name}</h3>
              <p className="mt-2 text-sm text-brand-muted">{s.why}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {s.how.map((h) => <span key={h} className="chip">{h}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
